var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-start align-items-center" },
          [
            _c("label", { staticClass: "text-bold mr-2 mb-0" }, [
              _vm._v("Override default currency")
            ]),
            _vm._v(" "),
            _c("AppToggle", {
              attrs: { disabled: !_vm.isPaid },
              model: {
                value: _vm.value.enabled,
                callback: function($$v) {
                  _vm.$set(_vm.value, "enabled", $$v)
                },
                expression: "value.enabled"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "AppAccordion",
        [
          _c(
            "AppAccordionItem",
            {
              staticClass: "mb-0 overflow-visible shadow-none mt-3",
              attrs: {
                showHeader: false,
                isWrapper: true,
                name: _vm.accordionId
              }
            },
            [
              _c("div", { staticClass: "px-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "currency-dropdown-wrapper col-md-6 col-xl-4 pb-4"
                  },
                  [
                    _c("AppDropdown", {
                      staticClass: "form-control",
                      attrs: {
                        options: _vm.currencyList,
                        reduce: "value",
                        label: "name",
                        clearable: false,
                        searchable: false
                      },
                      model: {
                        value: _vm.value.currency,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "currency", $$v)
                        },
                        expression: "value.currency"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "order-bump-section" }, [
      _c("div", { staticClass: "mb-3 text-sm" }, [
        _vm._v(
          "Customize this product's currency to better reflect its target customers."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }